import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Music, LogOut, Home, ArrowLeft } from 'lucide-react';
import { isAdminAuthenticated, adminLogout, getAdminUsername } from '@/utils/adminAuth';

export const AdminLayout = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAdminAuthenticated()) {
      navigate('/admin');
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background noise-texture">
      {/* Header */}
      <header className="bg-card border-b border-border/50 px-6 py-4 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Link to="/admin/dashboard" className="flex items-center gap-4 hover:opacity-80 transition-opacity">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary to-accent flex items-center justify-center shadow-glow">
                <Music className="w-6 h-6 text-black" />
              </div>
              <div>
                <h1 className="text-2xl font-bold font-display text-foreground">
                  Escola de Samba Casa Samba Admin
                </h1>
                <p className="text-sm text-muted-foreground">
                  Welcome back, {getAdminUsername()}
                </p>
              </div>
            </Link>
          </div>
          
          <div className="flex items-center gap-4">
            <Link
              to="/"
              className="flex items-center gap-2 px-4 py-2 text-muted-foreground hover:text-foreground border border-border hover:border-primary/50 rounded-full transition-all"
            >
              <Home className="w-4 h-4" />
              Store
            </Link>
            <button
              onClick={adminLogout}
              className="flex items-center gap-2 px-4 py-2 text-muted-foreground hover:text-foreground border border-border hover:border-primary/50 rounded-full transition-all"
            >
              <LogOut className="w-4 h-4" />
              Logout
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main>
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;
